"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = void 0;
var lazy = function () {
    var elements = document.querySelectorAll('.js-lazy');
    var observerOptions = {
        rootMargin: '0px',
        threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1],
    };
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var element = entry.target;
            var percentDistanceFromEdge = element.dataset.lazy_ratio ? parseInt(element.dataset.lazy_ratio) : 10;
            var intersectionRatio = entry.intersectionRatio;
            // remove delay from hero non visible elements
            if (element.classList.contains('-lazyIfVisible') && intersectionRatio < 0.1) {
                element.classList.forEach(function (className) {
                    if (className.indexOf('-lazyDelay') > -1) {
                        element.classList.remove(className);
                    }
                });
            }
            var viewportHeight = window.innerHeight;
            var elementHeight = element.clientHeight;
            var pixelsDistanceFromEdge = (percentDistanceFromEdge * viewportHeight) / 100;
            var elementThreshold = pixelsDistanceFromEdge / elementHeight > 0.9 ? 0.9 : pixelsDistanceFromEdge / elementHeight;
            intersectionRatio >= elementThreshold ? element.classList.add('-animated') : null;
        });
    }, observerOptions);
    elements.forEach(function (index) {
        if (index) {
            if (observer)
                observer.observe(index);
        }
    });
};
exports.lazy = lazy;
(0, exports.lazy)();
